<template>
  <form
    v-if="nativeSubmit"
    ref="form"
    v-bind="{ method: method === 'GET' ? 'GET' : 'POST' }"
    @keydown.ctrl.enter="form.submit"
    @keydown.meta.enter="form.submit"
  >
    <input v-if="requiresMethodInput" type="hidden" name="_method" :value="method">
    <input v-if="requiresTokenInput" type="hidden" name="_token" :value="token">
    <slot v-bind="{ form }"/>
  </form>
  <form
    v-else
    @keydown.ctrl.enter="$emit('submit')"
    @keydown.meta.enter="$emit('submit')"
    @submit.prevent="$emit('submit')"
  >
    <slot/>
  </form>
</template>

<script setup>
import { computed, ref } from "vue"

const props = defineProps({
  method: { type: String },
})

defineEmits(["submit"])

const form = ref()

const method = computed(() => props.method?.toUpperCase())

const nativeSubmit = computed(() => !!props.method)

const requiresMethodInput = computed(() => !["GET", "POST"].includes(method.value))

const requiresTokenInput = computed(() => method.value !== "GET")

const token = document.querySelector('meta[name="csrf-token"]').content
</script>
